const t = {
  name: "Section",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 1H22V15H2V1ZM4 3V13H20V3H4Z" fill="currentColor"/>
<path d="M11 19H2V17H11V19Z" fill="currentColor"/>
<path d="M2 23H11V21H2V23Z" fill="currentColor"/>
<path d="M22 19H13V17H22V19Z" fill="currentColor"/>
<path d="M13 23H22V21H13V23Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Section
};
